<template>
  <b-card-code>
    <b-form @submit.prevent="save(item)">
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Estado"
            label-for="status"
          >
            <v-select
              id="status"
              v-model="item.status"
              label="status"
              :options="statuses"
              :reduce="option => option.idStatus"
            />

          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Gerencia Directiva"
            label-for="type"
          >
            <b-form-input
              id="type"
              v-model="item.gerencia"
              placeholder="Gerencia Directiva"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Nº Centro Principal"
            label-for="type"
          >
            <b-form-input
              id="center"
              v-model="item.codigo"
              placeholder="Centro Principal"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Criterio de Distribución"
            label-for="criterio"
          >
            <v-select
              id="criterio"
              v-model="item.idCriterio"
              label="criterio"
              :options="criteria"
              :reduce="option => option.idCriterio"
            />

          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Porcentaje Distribución de Ingreso"
            label-for="ingresos"
          >
            <cleave
              id="ingresos"
              v-model="item.ingresos"
              class="form-control"
              :raw="true"
              :options="options.prefix"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Porcentaje Distribución de Gastos"
            label-for="gastos"
          >
            <cleave
              id="gastos"
              v-model="item.gastos"
              class="form-control"
              :raw="true"
              :options="options.prefix"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit and reset -->
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
          >
            <span v-if="!loading">Guardar</span>
            <span v-if="loading">Un momento...</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            to="../administrative-management"
          >
            Cancelar
          </b-button>
        </b-col>

        <p>{{ errorMessage }}</p>
      </b-row>
    </b-form>
  </b-card-code>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code'
import Cleave from 'vue-cleave-component'
import environment from '@/environment'

export default {
  name: 'CentersTypesAddVue',
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      item: {},
      loading: true,
      errorMessage: '',
      options: {
        prefix: {
          prefix: ' %',
          numeralIntegerScale: 2,
          numeralDecimalScale: 2,
          numeral: true,
          tailPrefix: true,
          numeralPositiveOnly: true,
          rawValueTrimPrefix: true,
        },
      },
    }
  },
  computed: {
    criteria() {
      return this.$store.getters['catalog/allCriteria'].filter(item => item.idCriterio !== 2 )
    },
    statuses() {
      return this.$store.getters['catalog/allStatuses']
    },
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      try {
        this.loading = true
        const { data } = await this.$http.get(`${environment.uri}/mngmts/id/${this.$route.params.id}`)
        this.item = data

        this.item.gastos *= 100
        this.item.ingresos *= 100
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    save(item) {
      this.loading = true
      this.errorMessage = ''

      console.log('item: ', item)

      const items = {
        ...item,
        gastos: (item.gastos / 100) || 0,
        ingresos: (item.ingresos / 100) || 0,
      }

      console.log('items: ', items)
      this.$http.put(`${environment.uri}/mngmts/update/id/${this.$route.params.id}`, items)
        .then(() => {
          this.loading = false
          this.$router.replace('/cda/administrative-management')
        })
        .catch(error => {
          console.error(error)
          this.errorMessage = (error && error.apiMessage) ? error.apiMessage : 'No fue posible procesar su solicitud'
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>

</style>
